(() => {
  const priceCache = new Map();

  const formatCardPrice = (data) => {
    if (!data || !data.price) return '';

    const unit = data.unit ? `<span class="dfd-card-price-unit">${data.unit}</span>` : '';
    return `<span class="dfd-card-price-value">${data.price}</span>${unit}`;
  };

  const getPriceUrl = (productUrl) => {
    try {
      const url = new URL(productUrl, window.location.origin);
      url.search = '';
      url.hash = '';
      url.searchParams.set('view', 'doofinder-price');
      return url.toString();
    } catch (error) {
      return '';
    }
  };

  const requestPriceData = (priceUrl) => {
    if (typeof window.fetch === 'function') {
      return window.fetch(priceUrl).then((response) => (response.ok ? response.json() : null));
    }

    return new Promise((resolve) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', priceUrl, true);
      xhr.onreadystatechange = () => {
        if (xhr.readyState !== 4) return;

        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            resolve(JSON.parse(xhr.responseText));
          } catch (error) {
            resolve(null);
          }
        } else {
          resolve(null);
        }
      };
      xhr.send();
    });
  };

  const updateCardPrice = async (card) => {
    const link = card.getAttribute('dfd-value-link') || card.querySelector('.dfd-card-link')?.href;
    const priceElement = card.querySelector('.dfd-card-price');

    if (!link || !priceElement) return;

    const priceUrl = getPriceUrl(link);
    if (!priceUrl) return;

    try {
      if (!priceCache.has(priceUrl)) {
        priceCache.set(priceUrl, requestPriceData(priceUrl).catch(() => null));
      }

      const data = await priceCache.get(priceUrl);
      const priceMarkup = formatCardPrice(data);

      if (!priceMarkup) return;
      if (priceElement.classList.contains('dfd-card-price--corrected') && priceElement.innerHTML === priceMarkup) {
        return;
      }

      priceElement.innerHTML = priceMarkup;
      priceElement.dataset.value = data.raw_price || '';
      priceElement.classList.add('dfd-card-price--corrected');
    } catch (error) {
      // Keep Doofinder's original price if the product view cannot be reached.
    }
  };

  const updateDoofinderCards = () => {
    document.querySelectorAll('.dfd-card-preset-product').forEach((card) => {
      updateCardPrice(card);
    });
  };

  let updateScheduled = false;
  const scheduleUpdate = () => {
    if (updateScheduled) return;

    updateScheduled = true;
    window.requestAnimationFrame(() => {
      updateScheduled = false;
      updateDoofinderCards();
    });
  };

  // Alleen de Doofinder-laag bekijken, niet de hele pagina: een observer op
  // document met attributes/characterData vuurde bij elke slideshow-, menu-
  // en animatiewijziging en kostte zo ~250 ms blokkeertijd (Lighthouse).
  const watchRoot = (root) => {
    updateDoofinderCards();
    new MutationObserver(scheduleUpdate).observe(root, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true,
    });
  };

  const findRoot = () => document.querySelector('.dfd-root');

  const start = () => {
    const root = findRoot();
    if (root) {
      watchRoot(root);
      return;
    }

    // .dfd-root wordt door Doofinder direct in <body> gezet; wacht daarop
    // zonder de rest van de pagina te observeren.
    const bodyObserver = new MutationObserver(() => {
      const found = findRoot();
      if (!found) return;
      bodyObserver.disconnect();
      watchRoot(found);
    });
    bodyObserver.observe(document.body, { childList: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
